// extracted by mini-css-extract-plugin
export default {"loadingPage":"Loadingpage_loadingPage__jzkJn","logo":"Loadingpage_logo__Gsaf+"};